import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem("admin_token")}` });

export default function DailyUsageReportPanel() {
  const [status, setStatus] = useState(null);
  const [report, setReport] = useState(null);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => {
    try {
      const [s, r] = await Promise.all([
        axios.get(`${API}/admin/daily-usage-report/status`, { headers: headers() }),
        axios.get(`${API}/admin/daily-usage-report`, { headers: headers() }),
      ]);
      setStatus(s.data);
      setReport(r.data);
    } catch { setMessage("Le bilan quotidien est indisponible. Réessayez dans un instant."); }
  };
  useEffect(() => { load(); }, []);
  const sendTest = async () => {
    setBusy(true);
    setMessage("");
    try {
      const r = await axios.post(`${API}/admin/daily-usage-report/test`, null, { headers: headers() });
      setMessage(r.data.status === "sent" ? "E-mail de test transmis à Resend pour torregrossa.joseph@gmail.com." : "Un envoi est déjà en cours.");
      await load();
    } catch { setMessage("L’envoi de test a échoué. Consultez la configuration Resend et réessayez."); }
    finally { setBusy(false); }
  };
  return <section className="neo-card p-4 space-y-3" data-testid="daily-usage-report">
    <h3 className="font-bold">Bilan quotidien Profimy App</h3>
    <p className="text-sm">Chaque matin à <strong>8h30, heure de Paris</strong>, bilan de la veille à torregrossa.joseph@gmail.com.</p>
    {status && <p className="text-sm">{status.enabled ? "Envoi automatique activé en production." : "Envoi automatique désactivé dans cet environnement."}
      {status.next_send && <> Prochain envoi : {new Date(status.next_send).toLocaleString("fr-FR", { timeZone: "Europe/Paris" })}.</>}
      {status.last_send && <> Dernier envoi accepté par Resend : {new Date(status.last_send.sent_at).toLocaleString("fr-FR", { timeZone: "Europe/Paris" })}.</>}
    </p>}
    {report && <div className="text-sm space-y-2">
      <p><strong>Journée du {report.day}</strong> : {report.users} utilisateurs actifs {report.users_complete ? "uniques" : "observés (journée partiellement suivie)"}, {report.new_users} nouveaux inscrits.</p>
      <p>Les comptes connectés sont comptés une seule fois par jour ; compte propriétaire exclu. Les visiteurs anonymes ne sont pas compris.</p>
      {report.actions.length > 0 && <ul>{report.actions.map(a => <li key={a._id}>{a._id} : {a.requests} requêtes, {a.errors} erreurs HTTP</li>)}</ul>}
      <p>Hébergement : <strong>50 crédits Emergent / mois</strong> (constaté le 08/10/2026), soit environ {report.hosting_daily_estimated_credits.toFixed(4)} crédits par jour. Coûts IA, RapidAPI et Resend : montants non reliés à la facturation.</p>
      <p>Coût total en euros : <strong>indisponible</strong>.</p>
    </div>}
    <div className="flex flex-wrap gap-2">
      <button onClick={load} className="neo-button-secondary px-3 py-2 text-xs">Actualiser le bilan</button>
      <button onClick={sendTest} disabled={busy || !status?.resend_configured} className="neo-button-primary px-3 py-2 text-xs">{busy ? "Envoi…" : "Envoyer un bilan de test"}</button>
    </div>
    {message && <p className="text-sm" role="status">{message}</p>}
  </section>;
}
